import axios from 'axios';
import * as apiURL from './apiConfig';

export const getProfileImages = async () => {
  try {
    const response = await axios.get(apiURL.PROFILE_IMAGES);
    return response.data.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
